import { createContext, useContext, useReducer } from 'react';

const LandingPageContext = createContext(null);

export const useLandingPageContext = () => {
  const ctx = useContext(LandingPageContext);
  if (!ctx) throw new Error('useLandingPageContext doit être utilisé dans <LandingPageProvider>');
  return ctx;
};

const initialState = {
  fetchAlert: false,
  alertMessage: '',
};

function reducer(state, action) {
  switch (action.type) {
    case 'PAGE_LANDING_STATES_UPDATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export function LandingPageProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { ...state, dispatch };
  return <LandingPageContext.Provider value={value}>{children}</LandingPageContext.Provider>;
}
